import GameRoom from "@/components/GameRoom";
export default function DailyTheme({ endless }) {
  return <GameRoom mode="theme" />;
}
